import { Component, OnInit ,ViewChild ,ElementRef } from '@angular/core';
import { BrdsqlService } from '../../services/brdsql.service';
import { ActivatedRoute, Router } from '@angular/router';
import Swal from 'sweetalert2';
import { Authenticationservice } from '../../services/authentication.service';

@Component({
  selector: 'app-editplot-part',
  templateUrl: './editplot-part.component.html',
  styleUrls: ['./editplot-part.component.css']
})
export class EditplotPartComponent implements OnInit {

  userdata:any = [];
  yearSelected:string = "";
  dataPart: any = [];
  @ViewChild('tb_dataPart') tb_dataPart!: ElementRef;

  constructor(    
    private brdservice: BrdsqlService,
    private auth:Authenticationservice,) { 
      this.yearSelected = localStorage.getItem('yearCr');
      this.userdata = this.auth.Authention();
    }

  ngOnInit(): void {
    this.requestDataPart();
  }

  // โหลดข้อมูลการขอแก้ไขแปลงของ ผจก.ส่วน
  requestDataPart() {
    let partcode = this.userdata.zonedata;
    this.dataPart = [];
    this.brdservice.listRequestEditPlotPart(partcode)
      .subscribe({
        next: (data: any) => {
          this.dataPart = data.recordset;
          setTimeout(() => {
            $(this.tb_dataPart.nativeElement).DataTable();
          }, 0);
        }, error: (e) => console.error(e)
      })
  } 

}
